/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiaglabSamples } from 'app/entities/diaglab-sample/diaglab-sample.reducer';
import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { getEntities as getDiaglabAssistants } from 'app/entities/diaglab-assistant/diaglab-assistant.reducer';
import { SampleStatus } from 'app/shared/model/enumerations/sample-status.model';
import { TypeOfSample } from 'app/shared/model/enumerations/type-of-sample.model';
import { UOM } from 'app/shared/model/enumerations/uom.model';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-sample-item.reducer';

export const DiaglabSampleItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diaglabSamples = useAppSelector(state => state.diaglabSample.entities);
  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const diaglabAssistants = useAppSelector(state => state.diaglabAssistant.entities);
  const diaglabSampleItemEntity = useAppSelector(state => state.diaglabSampleItem.entity);
  const loading = useAppSelector(state => state.diaglabSampleItem.loading);
  const updating = useAppSelector(state => state.diaglabSampleItem.updating);
  const updateSuccess = useAppSelector(state => state.diaglabSampleItem.updateSuccess);
  const sampleStatusValues = Object.keys(SampleStatus);
  const typeOfSampleValues = Object.keys(TypeOfSample);
  const uOMValues = Object.keys(UOM);

  const handleClose = () => {
    navigate(`/diaglab-sample-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiaglabSamples({}));
    dispatch(getUserLabTestItems({}));
    dispatch(getDiaglabAssistants({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.testSquence !== undefined && typeof values.testSquence !== 'number') {
      values.testSquence = Number(values.testSquence);
    }
    if (values.collectionDate !== undefined && typeof values.collectionDate !== 'number') {
      values.collectionDate = Number(values.collectionDate);
    }
    if (values.enteredDate !== undefined && typeof values.enteredDate !== 'number') {
      values.enteredDate = Number(values.enteredDate);
    }
    if (values.sendingdDate !== undefined && typeof values.sendingdDate !== 'number') {
      values.sendingdDate = Number(values.sendingdDate);
    }
    if (values.receivedDate !== undefined && typeof values.receivedDate !== 'number') {
      values.receivedDate = Number(values.receivedDate);
    }
    if (values.acceptingDate !== undefined && typeof values.acceptingDate !== 'number') {
      values.acceptingDate = Number(values.acceptingDate);
    }
    if (values.precessingDate !== undefined && typeof values.precessingDate !== 'number') {
      values.precessingDate = Number(values.precessingDate);
    }
    if (values.completionDate !== undefined && typeof values.completionDate !== 'number') {
      values.completionDate = Number(values.completionDate);
    }
    if (values.verificationDate !== undefined && typeof values.verificationDate !== 'number') {
      values.verificationDate = Number(values.verificationDate);
    }
    if (values.authenticationDate !== undefined && typeof values.authenticationDate !== 'number') {
      values.authenticationDate = Number(values.authenticationDate);
    }
    if (values.releasedDate !== undefined && typeof values.releasedDate !== 'number') {
      values.releasedDate = Number(values.releasedDate);
    }
    if (values.transmissionDate !== undefined && typeof values.transmissionDate !== 'number') {
      values.transmissionDate = Number(values.transmissionDate);
    }

    const entity = {
      ...diaglabSampleItemEntity,
      ...values,
      sample: diaglabSamples.find(it => it.id.toString() === values.sample?.toString()),
      labTestItem: userLabTestItems.find(it => it.id.toString() === values.labTestItem?.toString()),
      collector: diaglabAssistants.find(it => it.id.toString() === values.collector?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'NotTested',
          typeOfSample: 'Serum',
          uom: 'Femtoliters',
          ...diaglabSampleItemEntity,
          sample: diaglabSampleItemEntity?.sample?.id,
          labTestItem: diaglabSampleItemEntity?.labTestItem?.id,
          collector: diaglabSampleItemEntity?.collector?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabSampleItem.home.createOrEditLabel" data-cy="DiaglabSampleItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabSampleItem.home.createOrEditLabel">Create or edit a DiaglabSampleItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-sample-item-id"
                  label={translate('tinyMedicRestApp.diaglabSampleItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.itemAccessionNo')}
                id="diaglab-sample-item-itemAccessionNo"
                name="itemAccessionNo"
                data-cy="itemAccessionNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.referredToOrFrom')}
                id="diaglab-sample-item-referredToOrFrom"
                name="referredToOrFrom"
                data-cy="referredToOrFrom"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.quantity')}
                id="diaglab-sample-item-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.active')}
                id="diaglab-sample-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.cursor')}
                id="diaglab-sample-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.lastUpdated')}
                id="diaglab-sample-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.microSec')}
                id="diaglab-sample-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.timestampEntry')}
                id="diaglab-sample-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.status')}
                id="diaglab-sample-item-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {sampleStatusValues.map(sampleStatus => (
                  <option value={sampleStatus} key={sampleStatus}>
                    {translate(`tinyMedicRestApp.SampleStatus.${sampleStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.typeOfSample')}
                id="diaglab-sample-item-typeOfSample"
                name="typeOfSample"
                data-cy="typeOfSample"
                type="select"
              >
                {typeOfSampleValues.map(typeOfSample => (
                  <option value={typeOfSample} key={typeOfSample}>
                    {translate(`tinyMedicRestApp.TypeOfSample.${typeOfSample}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.testSquence')}
                id="diaglab-sample-item-testSquence"
                name="testSquence"
                data-cy="testSquence"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.rejectReason')}
                id="diaglab-sample-item-rejectReason"
                name="rejectReason"
                data-cy="rejectReason"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.uom')}
                id="diaglab-sample-item-uom"
                name="uom"
                data-cy="uom"
                type="select"
              >
                {uOMValues.map(uOM => (
                  <option value={uOM} key={uOM}>
                    {translate(`tinyMedicRestApp.UOM.${uOM}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.collectionDate')}
                id="diaglab-sample-item-collectionDate"
                name="collectionDate"
                data-cy="collectionDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.enteredDate')}
                id="diaglab-sample-item-enteredDate"
                name="enteredDate"
                data-cy="enteredDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.sendingdDate')}
                id="diaglab-sample-item-sendingdDate"
                name="sendingdDate"
                data-cy="sendingdDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.receivedDate')}
                id="diaglab-sample-item-receivedDate"
                name="receivedDate"
                data-cy="receivedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.acceptingDate')}
                id="diaglab-sample-item-acceptingDate"
                name="acceptingDate"
                data-cy="acceptingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.precessingDate')}
                id="diaglab-sample-item-precessingDate"
                name="precessingDate"
                data-cy="precessingDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.completionDate')}
                id="diaglab-sample-item-completionDate"
                name="completionDate"
                data-cy="completionDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.verificationDate')}
                id="diaglab-sample-item-verificationDate"
                name="verificationDate"
                data-cy="verificationDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.authenticationDate')}
                id="diaglab-sample-item-authenticationDate"
                name="authenticationDate"
                data-cy="authenticationDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.releasedDate')}
                id="diaglab-sample-item-releasedDate"
                name="releasedDate"
                data-cy="releasedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabSampleItem.transmissionDate')}
                id="diaglab-sample-item-transmissionDate"
                name="transmissionDate"
                data-cy="transmissionDate"
                type="text"
              />
              <ValidatedField
                id="diaglab-sample-item-sample"
                name="sample"
                data-cy="sample"
                label={translate('tinyMedicRestApp.diaglabSampleItem.sample')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabSamples
                  ? diaglabSamples.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-sample-item-labTestItem"
                name="labTestItem"
                data-cy="labTestItem"
                label={translate('tinyMedicRestApp.diaglabSampleItem.labTestItem')}
                type="select"
                required
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="diaglab-sample-item-collector"
                name="collector"
                data-cy="collector"
                label={translate('tinyMedicRestApp.diaglabSampleItem.collector')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabAssistants
                  ? diaglabAssistants.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-sample-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabSampleItemUpdate;
